import { QueryClient } from "@tanstack/react-query";

// Create a client
export const queryClient = new QueryClient();
